import React from "react";
import MercantilTDC from "./Bolivares/MercantilTDC";
import MasterDebit from "./Bolivares/MasterDebit";
import Pagomovil from "./Bolivares/Pagomovil";
import Zelle from "./Dolares/Zelle";
import TarjetaCreditoEX from "./Dolares/TarjetaCreditoEX";
import DebitoNacional from "./Bolivares/DebitoNacional";


function SelectPayment({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
}) {
  return (
    <div>
      {data?.metodoPago?.title === "Débito Nacional" && (
        <>
          <DebitoNacional
            data={data}
            setData={setData}
            stapsState={stapsState}
            setStapsState={setStapsState}
            back={back}
            deatils={deatils}
          />
        </>
      )}
      {data?.metodoPago?.title === "Pago Móvil" && (
        <>
          <Pagomovil
            data={data}
            setData={setData}
            stapsState={stapsState}
            setStapsState={setStapsState}
            back={back}
            deatils={deatils}
          />
        </>
      )}
      {data?.metodoPago?.title === "Crédito Nacional" && (
        <>
          <MercantilTDC
            data={data}
            setData={setData}
            stapsState={stapsState}
            setStapsState={setStapsState}
            back={back}
            deatils={deatils}
          />
        </>
      )}
      {data?.metodoPago?.title === "Zelle" && (
        <>
          <Zelle
            data={data}
            setData={setData}
            stapsState={stapsState}
            setStapsState={setStapsState}
            back={back}
            deatils={deatils}
          />
        </>
      )}
      {data?.metodoPago?.title === "Tarjeta Internacional" && (
        <>
          <TarjetaCreditoEX
            data={data}
            setData={setData}
            stapsState={stapsState}
            setStapsState={setStapsState}
            back={back}
            deatils={deatils}
          />
        </>
      )}
      {data?.metodoPago?.title === "Master Debit" && (
        <>
          <MasterDebit
            data={data}
            setData={setData}
            stapsState={stapsState}
            setStapsState={setStapsState}
            back={back}
            deatils={deatils}
          />
        </>
      )}
    </div>
  );
}

export default SelectPayment;
